<template>
  <v-container id="login" fill-height fluid style="overflow=hidden">
    <v-row justify="center">
      <v-col xs="12" sm="3">
        <v-card>
          <v-card-text>
            <router-view> </router-view>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-layout class="text-center" align-center="align-center" justify-center row fill-height="fill-height">
        <v-flex xs12 sm2="sm2" md2="md2" lg2="lg2">
            
        </v-flex>
    </v-layout> -->
  </v-container>
</template>
<script>
export default {
  name: "authentication"
};
</script>
<style scoped>
#login {
  background-image: url(http://backgrounddownload.com/wp-content/uploads/2018/09/cool-orange-background-designs-7.jpg);
  background-size: cover;
}
</style>
